import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

// Importar todos os logos
import logoIel from '../../assets/logo-iel.png';
import logoSesi from '../../assets/logo-sesi.png';
import logoSenai from '../../assets/logo-senai.png';
import logoFieac from '../../assets/logo-fieac.png';
import logoSistemaFieac from '../../assets/logo-sistema-fieac-casas.png';

const LOGOS = [
  { src: logoIel, alt: 'IEL' },
  { src: logoSesi, alt: 'SESI' },
  { src: logoSenai, alt: 'SENAI' },
  { src: logoFieac, alt: 'FIEAC' },
  { src: logoSistemaFieac, alt: 'Sistema FIEAC' },
];

export const AnimatedLogos = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const isFinalLogo = currentIndex === LOGOS.length - 1;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % LOGOS.length);
    }, isFinalLogo ? 3500 : 2000); // 3.5s para o logo final (3s de pausa + 0.5s de transição), 2s para os outros

    return () => clearInterval(interval);
  }, [isFinalLogo]);

  return (
    <div className="relative w-15 h-15 overflow-hidden flex-shrink-0">
      <AnimatePresence mode="wait">
        <motion.div
          key={currentIndex}
          initial={{ y: '100%', opacity: 0 }}
          animate={{ 
            y: 0, 
            opacity: 1,
            scale: isFinalLogo ? [1, 1.05, 1] : 1
          }}
          exit={{ y: '-100%', opacity: 0 }}
          transition={{ 
            duration: 0.6,
            ease: 'easeInOut',
            scale: {
              duration: 1.5,
              repeat: isFinalLogo ? 2 : 0,
              repeatType: 'loop',
              ease: 'easeInOut'
            }
          }}
          className="absolute inset-0 flex items-center justify-center"
        >
          <img
            src={LOGOS[currentIndex].src}
            alt={LOGOS[currentIndex].alt}
            className="max-w-full max-h-full object-contain"
          />
        </motion.div>
      </AnimatePresence>
    </div>
  );
};
